import { TemplateExportTypeEnum } from '../enums';
import { FileModel } from '../file.model';
import { LocalizedValueModel } from '../localized-value.model';

export enum TemplateLevelEnum {
  SingleEntry = 0,
  MultipleEntries = 1,
}
export enum TemplateTypeEnum {
  Word = 0,
  PDF = 1,
  Excel = 2,
}

export class DataEntityTemplatePresenterModel {
  /**
   * The id of the template
   */
  id: string;
  /**
   * The name of the template
   */
  name: LocalizedValueModel;
  /**
   * The level of the template. This can be either SingleEntry or MultipleEntries
   */
  level: TemplateLevelEnum;
  /**
   * The file for the template
   */
  file: FileModel;
  /**
   * The type of the template. This can be either Word, PDF, or Excel
   */
  type: TemplateTypeEnum;
  /*
   * export type either UI or Background (default is background)
   */
  exportType: TemplateExportTypeEnum;

  /**
   * The list of additional properties to be calculated in the template for each entry
   * {
   *   'my-new-full-name': 'value.first_name + value.last_name'
   * }
   */
  additionalProperties: Record<string, string>;
}
